'use client'

import { useEffect } from 'react'

import { captureClientException } from '@/lib/analytics/capture-client-exception'
import {
  hardReloadForStaleDeploy,
  isLikelyStaleDeployError,
  tryRecoverFromStaleDeploy
} from '@/lib/utils/stale-deploy-recovery'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    if (isLikelyStaleDeployError(error) && tryRecoverFromStaleDeploy()) {
      return
    }

    captureClientException(error, {
      source: 'app-error-boundary',
      boundary: 'app-error-boundary',
      severity: 'error'
    })
  }, [error])

  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-4 p-6">
      <h2 className="text-foreground text-lg font-semibold">Something went wrong</h2>
      <button
        onClick={() => {
          if (isLikelyStaleDeployError(error)) {
            hardReloadForStaleDeploy()
            return
          }
          reset()
        }}
        className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-4 py-2 text-sm font-medium"
      >
        Try again
      </button>
    </div>
  )
}
